import React, { useContext, useState } from "react";
import { Button, Alert, CircularProgress, Typography } from "@mui/material";
import useAxios from "../../../hooks/useAxios";
import "./LoginViaCodeForm.css";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import WhiteInputField from '../../common/StyledComponents/WhiteInputField/WhiteInputField';

const LoginViaCodeForm = ({ setCurrentStep }) => {
  const [loginCode, setLoginCode] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const axiosInstance = useAxios();
  const { setToken, setRole, setStatus } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginCode.trim()) {
      setError("Please enter your login code");
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const response = await axiosInstance.post("/login-with-code", {
        login_code: loginCode.trim()
      });

      if (response.data.success) {
        setToken(response.data.token);
        setRole(response.data.role);
        setStatus(response.data.status);
        navigate('/');
      } else {
        setError(response.data.message || "Login failed");
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Invalid login code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    setCurrentStep("login");
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <h2 className="form-title">Login with Code</h2>
      
      {error && <Alert severity="error">{error}</Alert>}

      <WhiteInputField
        className="custom-text-field"
        label="Login Code"
        value={loginCode}
        onChange={(e) => setLoginCode(e.target.value)}
        placeholder="Enter your login code"
        required
        autoFocus
      />

      <Button
        type="submit"
        className="submit-button primary-button"
        disabled={loading || !loginCode.trim()}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Login with Code"}
      </Button>

      <Button
        onClick={handleBackToLogin}
        className="white-text-button"
      >
        Back to Regular Login
      </Button>
    </form>
  );
};

export default LoginViaCodeForm; 